import React from 'react';
import styles from "./Layers.module.scss";
import ImageWrapper from "components/imageWrapper/ImageWrapper";
import layerStyles from "components/homePanels/f-i_macroPage/heroLayers/Layers.module.scss";

const BonusGround = (props) => {

    function buildBonusGround(){
        if(props.macro === 'martellus'){
            return (
                <>
                    <div className={styles.bonusChildWrapper}>
                        <ImageWrapper className={`${styles.bgLayer} ${styles.martellus_bonusRainLft}`} set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-bonus-rain-left.png'}} alt={'Rain left'}/>
                        <ImageWrapper className={`${styles.bgLayer} ${styles.martellus_bonusRainRt}`} set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-bonus-rain-right.png'}} alt={'Rain right'}/>
                        <ImageWrapper className={`${styles.bgLayer} ${styles.martellus_bonusCloudTopCtr}`} set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-bonus-cloud-top-center-DUPE.png'}} alt={'Cloud top right'}/>
                        <ImageWrapper className={`${styles.bgLayer} ${styles.martellus_bonusCloudTopLft}`} set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-bonus-cloud-top-left-DUPE.png'}} alt={'Cloud mid left'}/>

                        <ImageWrapper className={`${styles.bgLayer} ${styles.martellus_bonusBee}`} set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-bonus-bee.png'}} alt={'Bee'}/>
                        <ImageWrapper className={`${styles.bgLayer} ${styles.martellus_bonusGirl}`} set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-bonus-girl.png'}} alt={'Girl'}/>

                    </div>
                </>
            )
        }

        if(props.macro === 'cache'){
            return (
                <>
                    <div className={styles.bonusChildWrapper}>
                        <ImageWrapper className={`${styles.bgLayer} ${styles.cache_bonusSquare}`}
                                      set={{
                                          400:'https://msobd-storage.azureedge.net/images/profile_cache/bg-squarex400.png',
                                          800:'https://msobd-storage.azureedge.net/images/profile_cache/bg-squarex800.png',
                                          default:'https://msobd-storage.azureedge.net/images/profile_cache/bg-square.png'}}
                                      alt={'Square'}/>
                    </div>
                </>
            )
        }

        if(props.macro === 'brooke'){

            return (
                <>
                    <div className={styles.bonusChildWrapper}>
                        <div  className={`${layerStyles.brooke_filmBgLeft} ${layerStyles.brooke_filmBgHero}`}/>
                        <div  className={`${layerStyles.brooke_filmBgRight} ${layerStyles.brooke_filmBgHero}`}/>
                    </div>
                </>
            )
        }

        if(props.macro === 'deadmau5'){

            return (
                <>
                    <div className={styles.bonusChildWrapper}>
                        <ImageWrapper className={`${styles.bgLayer} ${styles.deadmau5_spotlight}`}
                                      set={{
                                          800:'https://msobd-storage.azureedge.net/images/profile_deadmau5/foreground_spotlights_800.png',
                                          1350:'https://msobd-storage.azureedge.net/images/profile_deadmau5/foreground_spotlights_1350.png',
                                          default:'https://msobd-storage.azureedge.net/images/profile_deadmau5/foreground_spotlights.png'}}
                                      alt={'Square'}/>
                    </div>
                </>
            )
        }

        else  return '';
    }

    return buildBonusGround()
};

export default BonusGround
